import { render } from "./Acceptance.vue?vue&type=template&id=b51481aa"
import script from "./Acceptance.vue?vue&type=script&lang=js"
export * from "./Acceptance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/residence/Acceptance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b51481aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b51481aa', __exports__)) {
    api.reload('b51481aa', __exports__)
  }
  
  module.hot.accept("./Acceptance.vue?vue&type=template&id=b51481aa", () => {
    api.rerender('b51481aa', render)
  })

}


export default __exports__